const FALLBACK_API_URL = 'http://localhost:4000';

function readRuntimeOverride() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem('apiBaseOverride');
  } catch {
    return null;
  }
}

function normalize(url) {
  if (!url) return '';
  return url.replace(/\/+$/, '');
}

const buildTimeUrl = process.env.REACT_APP_API_URL;
const sameOriginApi = process.env.REACT_APP_SAME_ORIGIN === 'true';

function computeApiBase() {
  const runtime = readRuntimeOverride();
  if (runtime != null && runtime !== '') return normalize(runtime);

  if (typeof buildTimeUrl === 'string' && buildTimeUrl.length > 0) {
    return normalize(buildTimeUrl);
  }
  if (sameOriginApi || buildTimeUrl === '') {
    return '';
  }
  if (process.env.NODE_ENV !== 'production') {
    return normalize(FALLBACK_API_URL);
  }
  return normalize(FALLBACK_API_URL);
}

export const API_URL = computeApiBase();

export const ENV = {
  apiUrl: API_URL,
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV !== 'production'
};

export default ENV;
